import { Prefooter } from './Prefooter';

export type { TypePrefooterProps } from './types';
export default Prefooter;
